import SocketEvent from "./abstract/SocketEvent"
import { OnAnalysisMessageReadyEventKey, OnAnalysisMessageReadyEventPayload } from "pokal_api"
import { analysisMessageReadySlice } from "../redux/AnalysisMessageReady"

// just stores the pushed message in Redux; useChatStream reads it for its own conversationId
const OnAnalysisMessageReadyEvent: SocketEvent<OnAnalysisMessageReadyEventPayload> =
    new SocketEvent(OnAnalysisMessageReadyEventKey, (args, _input, dispatch) => {
        dispatch(analysisMessageReadySlice.actions.messageReady(args))
    })

export default OnAnalysisMessageReadyEvent
